import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const faqs = [
    {
      question: "Comment fonctionne l'achat de leads qualifiés ?",
      answer: "Vous choisissez les leads qui correspondent à votre zone d'intervention et à vos compétences. Une fois achetés, vous recevez instantanément les coordonnées complètes du client et les détails de son projet. Vous pouvez alors le contacter directement pour établir un devis."
    },
    {
      question: "Les leads sont-ils exclusifs ?",
      answer: "Oui, chaque lead est vendu à un nombre limité d'artisans (maximum 3) pour vous garantir un taux de conversion optimal. Vous n'êtes jamais en concurrence avec des dizaines d'autres professionnels."
    },
    {
      question: "Quel est le délai de réponse recommandé ?",
      answer: "Nous recommandons de contacter le client dans les 2 heures suivant l'achat du lead. Les statistiques montrent que 65% des clients choisissent le premier artisan qui les contacte. La rapidité est un facteur clé de succès."
    },
    {
      question: "Comment sont qualifiés les leads ?",
      answer: "Chaque lead passe par un processus de qualification rigoureux : vérification du projet, validation du budget, confirmation de la zone géographique et vérification du délai souhaité. Nous éliminons les demandes non sérieuses."
    },
    {
      question: "Que se passe-t-il si le lead n'est pas valide ?",
      answer: "Si vous constatez qu'un lead ne correspond pas à la description ou que les coordonnées sont incorrectes, contactez-nous dans les 48h. Nous vérifions la situation et vous remboursons ou créditons votre compte si le lead n'est effectivement pas conforme."
    },
    {
      question: "Puis-je choisir ma zone d'intervention ?",
      answer: "Absolument ! Vous définissez précisément vos zones d'intervention par département ou ville. Vous ne recevez que des leads correspondant à vos critères géographiques. Vous pouvez modifier ces paramètres à tout moment."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Questions Fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Tout ce que vous devez savoir sur nos leads qualifiés
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-lg font-bold text-gray-900 pr-4">{faq.question}</span>
                <div className={`w-8 h-8 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-white text-xl"></i>
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}>
                <div className="px-8 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-gradient-to-r from-blue-600 to-teal-600 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-white mb-4">
            Vous avez d'autres questions ?
          </h3>
          <p className="text-blue-100 mb-6">
            Notre équipe est là pour vous aider à développer votre activité
          </p>
          <button 
            onClick={() => scrollToSection('contact')}
            className="inline-flex items-center gap-2 bg-white text-blue-600 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-customer-service-line text-xl"></i>
            Contactez-nous
          </button>
        </div>
      </div>
    </section>
  );
}
